export const GetStorage = (key) => {
  return (
    localStorage.getItem(key) || sessionStorage.getItem(key)
  );
};

export const RemoveStorage = (key) => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

export const SetStorage = (key, value, place = "session") => {
  if (place === "local") {
    localStorage.setItem(key, value);
  } else { // place = session
    sessionStorage.setItem(key, value);
  };
};